import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const Heading = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  ${typographyMixin("caption", 3)}
  font-weight: 600;
`;

export const Grid = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${spacing[1.5]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Thumb = styled.li<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  min-width: 0;
  padding: ${({ $active }) => ($active ? "calc(0.375rem - 1px)" : spacing[1.5])};
  border: ${({ $active }) => ($active ? "2px" : "1px")} solid
    ${({ $active, theme }) => ($active ? theme.colors.interactive.primary : theme.colors.border.stroke)};
  border-radius: ${borderRadius.sm};
`;

export const Line = styled.i<{ $short?: boolean }>`
  display: block;
  width: ${({ $short }) => ($short ? "70%" : "100%")};
  height: 0.3125rem;
  border-radius: ${borderRadius.xs};
  background: ${({ theme }) => theme.colors.border.subtle};
`;

export const More = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.sm};
  color: ${({ theme }) => theme.colors.text.secondary};
  ${typographyMixin("caption", 3)}
  font-weight: 600;
`;
